import React from 'react';

import { useTracking } from '@zego/tracking';

import ButtonLink from '@zego/components/button/ButtonLink';
import ScrollToElement from '@zego/components/ScrollToElement';

const HeroButton = ({ label, selector, color = null }) => {
  const { trackEvent } = useTracking();

  return (
    <ScrollToElement
      selector={selector}
      render={scroll => (
        <ButtonLink
          href={selector}
          onClick={event => {
            event.preventDefault();
            trackEvent('Hero Button Click');
            scroll();
          }}
          backgroundColor={color}
        >
          {label}
        </ButtonLink>
      )}
    />
  );
};

export default HeroButton;
